/**
 * A Parameter appears to be a value set by a slider of some sort, but really, who knows ¯\_(ツ)_/¯
 */
import PropTypes from 'prop-types';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';
import React, { Component } from 'react';

import { Col, Form, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import {
    isParametersOrVariablesUpdatedAction,
    revenueParametersAction,
} from '../../../../../stores/actions/modelInputReader';
import './baseParametersStyle.scss';

class BaseParameters extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabLabel: 'Base Parameters Tab',
            rpMinMax: {},
            paramGroup: '',
            inputParams: {},
            originalParams: [],
            errors: {
                message: [],
            },
            sumErrors: {
                message: [],
            },
            validated: null,
        };
        this.getMinMax = this.getMinMax.bind(this);
        this.getTipProps = this.getTipProps.bind(this);
        this.siderAfterChange = this.siderAfterChange.bind(this);
        this.createSliderElement = this.createSliderElement.bind(this);
        this.createNumberElement = this.createNumberElement.bind(this);
    }

    /**
     * Rendering ui elements
     */
    render() {
        let { originalParams } = this.state;

        let elements = [];
        let logs = {};
        let parameterData = [];

        if (this.props.flags && this.props.flags.resetOriginalValuesFlag) {
            originalParams.length = 0;
        }

        if (
            this.props.getInitialModels &&
            this.props.getInitialModels.initial
        ) {
            parameterData = this.props.getInitialModels.initial.parameters;
            parameterData.forEach((param) => {
            	if (this.props.paramGroup === param.group) {
	                param.parameter.forEach((elem) => {
	                    let input_field;
	                    if (elem.parameterDisplayType === "Scroll") {
	                      input_field = this.createSliderElement(elem);
	                    } else {
	                      input_field = this.createNumberElement(elem);
	                    }
	                    elements.push(input_field);
	                }, logs);
            	}
            }, logs);
        }

        // split elements into 2 columns
        let col_elements = [[], []];
        if (elements.length > 0) {
            let mid = Math.ceil(elements.length / 2);
            col_elements[0] = elements.splice(0, mid);
            col_elements[1] = elements;
        }

        return (
            <div className="rev-param-box">
                <Row>
                    <Col className="col-5">{col_elements[0]}</Col>
                    <Col className="col-1" />
                    <Col className="col-5 pr-5">{col_elements[1]}</Col>
                </Row>
            </div>
        );
    }

    /**
     * Create slider elements
     */
    createSliderElement(elemProperties) {
        const attribs = this.checkForChange(elemProperties);

        const Slider2 = createSliderWithTooltip(Slider);

        return (
            <Form.Group as={Row} key={elemProperties.parameterId} controlId={elemProperties.parameterId}>
                <Col xs={6} sm={6} md={5} lg={5}>
                    <Form.Label className="element-label">{elemProperties.parameterName}</Form.Label>
                </ Col>
                <Col xs={6} sm={6} md={3} lg={2.5} xl={2}>
                    <Form.Control className={attribs.className} data-testid="form-control-input" column onChange={(e) => this.inputChange(e, elemProperties)} value={elemProperties.parameterValue} placeholder={elemProperties.parameterValue} id={`input-${elemProperties.parameterId}`} />
                </ Col>
                <Col sm={8} md={8} lg={5}>
                    <Slider2
                        min={elemProperties.minValue}
                        step={elemProperties.scaleStep}
                        max={elemProperties.maxValue}
                        tipProps={this.getTipProps()}
                        tipFormatter={(value) => `${value}%`}
                        defaultValue={elemProperties.parameterValue}
                        onAfterChange={(val) =>
                            this.siderAfterChange(val, elemProperties.parameterValue, elemProperties.parameterId)
                        }
                        marks={this.getMinMax(elemProperties.minValue, elemProperties.maxValue)}
                    />
                </Col>
            </Form.Group>
        );
    }

    /**
     * Create number Input elements
     */
    createNumberElement(elemProperties) {
        const attribs = this.checkForChange(elemProperties);

        const isError = this.state.errors.message.indexOf(elemProperties.parameterName);

        return (
            <Form.Group as={Row} key={elemProperties.parameterId} controlId={elemProperties.parameterId}>
                <Form.Label className="col-12" column sm={12} md={7} lg={6}>
                    {elemProperties.parameterName}
                </Form.Label>
                <Col className="col-12" sm={12} md={5} lg={6}>
                    <Form.Control
                        size="sm"
                        onKeyPress={this.changeNumber}
                        onPaste={this.blockCopyPasteCharacters}
                        as="input"
                        type="number"
                        onChange={(e) => this.inputChange(e, elemProperties)}
                        name={elemProperties.parameterName}
                        value={elemProperties.parameterValue ? elemProperties.parameterValue : ''}
                        min={elemProperties.minValue}
                        max={elemProperties.maxValue}
                        step={elemProperties.scaleStep}
                        className={attribs.className}
                        title={attribs.title}
                    />
                    {isError !== -1 ? (
                        <span className="error">
                            Please enter a number between {elemProperties.minValue} & {elemProperties.maxValue}{' '}
                        </span>
                    ) : null}
                </Col>
            </Form.Group>
        );
    }

    /**
     * Checks if the field has changed by looking at the originalParams
     * returns className and title attributes for the element
     */
    checkForChange(elemProperties) {
        let { originalParams } = this.state;
        let className = 'form-control-sm mt-2';
        let title = '';
        const fieldId = elemProperties.parameterId;
        if (originalParams[fieldId] !== undefined && +originalParams[fieldId] !== +elemProperties.parameterValue) {
            title = 'original: ' + originalParams[fieldId];
            className = 'form-control-sm mt-2 param-edited';
        }
        return {
            className: className,
            title: title,
        };
    }

    /**
     * Initializes the originalParams from current values
     */
    initializeOriginalParams(fieldId, oldValue) {
        let { originalParams } = this.state;
        if (originalParams[fieldId] === undefined) {
            originalParams[fieldId] = +oldValue;
        }
    }

    /**
     * Block the characters other than numbers on key press.
     */
    changeNumber = (event) => {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode !== 46 && charCode > 31 && (charCode < 48 || charCode > 57)) {
            event.preventDefault();
        }
    };

    /**
     * Block the characters other than numbers on copy and paste.
     */
    blockCopyPasteCharacters = (window) => {
        if (window.clipboardData.getData('Text').match(/[^0-9.]/)) {
            window.preventDefault();
        }
    };

    /**
     * Triggers after changing the slider.
     */
    siderAfterChange(value, oldValue, fieldId) {
        this.initializeOriginalParams(fieldId, oldValue);

        let logs = {};
        let obj = this.props.getInitialModels.initial.parameters;

        obj.forEach((param) => {
            param.parameter.forEach((elem) => {
                if (elem.parameterId === fieldId) {
                    elem.parameterValue = value;
                }
            }, logs);
        }, logs);

        this.props.updateState(obj);
        this.props.setParametersUpdated(true, this.props.paramGroup);
    }

    /**
     * Triggers on change of input value.
     */
    inputChange(evt, properties) {
        const fieldId = properties.parameterId;
        const oldValue = properties.parameterValue;
        this.initializeOriginalParams(fieldId, oldValue);

        const { errors } = this.state;
        const errorIndex = errors.message.indexOf(properties.parameterName);
        if (evt.target.value < properties.minValue || evt.target.value > properties.maxValue) {
            if (errorIndex === -1) {
                errors.message.push(properties.parameterName);
                setTimeout(() => {
                    errors.message.splice(errors.message.indexOf(properties.parameterName), 1);
                    this.setState({
                        validated: !!errors.message.length,
                        errors,
                    });
                }, 2000);
            }
        } else {
            if (errorIndex !== -1) {
                errors.message.splice(errorIndex, 1);
            }
        }
        this.setState({
            validated: !!errors.message.length,
            errors,
        });
        /**
         * Update value in state
         */
        if ((evt.target.value >= properties.minValue && evt.target.value <= properties.maxValue) || (evt.target.value === "-")) {
            let cleanedInput = this.cleanUserInput(evt.target.value, properties)

            let logs = {}
            let obj = {};

            obj = this.props.getInitialModels.initial.parameters;
            obj.forEach((param) => {
                param.parameter.forEach((elem) => {
                    if (elem.parameterId === fieldId) {
                        elem.parameterValue = cleanedInput;
                    }
                }, logs);
            }, logs);

            this.props.updateState(obj);
            this.props.setParametersUpdated(true, this.props.paramGroup);
        }
    }

    /**
     * Cleans user input value and returns valid entries
     * @param {*} min min value
     * @param {*} max max value
     */
    cleanUserInput(inputValue, properties) {
        let cleanValue = inputValue.trim()
        if (properties.minValue >= 0 && cleanValue === "-") {
            return 0
        }
        if (properties.minValue <= 0 && cleanValue === "-") {
            return "-"
        }
        if (cleanValue === "") {
            return ""
        }
        if (cleanValue.length > 5) {
            cleanValue = cleanValue.slice(0,5)
        }
        if (cleanValue.charAt(cleanValue.length - 1) === ".") {
            return cleanValue
        }
        return cleanValue * 1
    }    


    /**
     * Get min max
     * @param {*} min min value
     * @param {*} max max value
     */
    getMinMax(min, max) {
        let marks = {};
        let mid = max / 2;
        marks[min] = min + '%';
        marks[mid] = mid + '%';
        marks[max] = max + '%';
        return marks;
    }

    /**
     * Get tips props
     */
    getTipProps() {
        return { placement: 'top', visible: false };
    }
}

/**
 * Set request state to prop
 * @param {*} state state
 */
const MapStateToProps = (state) => {
    return {
        getActualModels: state.getActualAction,
        getInitialModels: state.getInitialAction,
        initialModelInputData: state.revParamAction,
        actualModelInputData: state.inpVarblAction,
        modelDetails: state.modelChangeAction,
        flags: state.resetOriginalValuesFlag,
    };
};

/**
 * Dispatching props
 * @param {*} dispatch dispatch
 */
const MapDispatchToProps = (dispatch) => {
    return {
        updateState: (inputParams) =>
            dispatch(
                revenueParametersAction(inputParams),
            ),
        setParametersUpdated: (status, group) =>
            dispatch(
                isParametersOrVariablesUpdatedAction({
                    status: status,
                    group: group,
                }),
            ),
    };
};

BaseParameters.propTypes = {
    updateState: PropTypes.func,
    setParametersUpdated: PropTypes.func,
    modelDetails: PropTypes.object,
    initialModelInputData: PropTypes.object,
    actualModelInputData: PropTypes.object,
    getActualModels: PropTypes.object,
    getInitialModels: PropTypes.object,
    boxClasses: PropTypes.string,
    flags: PropTypes.object,
    paramGroup: PropTypes.string,
};

export default connect(MapStateToProps, MapDispatchToProps)(BaseParameters);
